
import React, { useState, useEffect } from "react";
import "./DasboardTransformer.css";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { URL } from "../../config";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const LineChartComponent = ({ area, service, setArea, setService }) => {
  const areaData = {
    "Química": {
      "Taninos": {
        kg: [],
        processos: [],
      },
      "Ácido Tânico": {
        kg: [],
        processos: [],
      },
    },
    "Biologia": {
      "Fermentação": {
        kg: [],
        processos: [],
      },
    },
  };

  // Ajuste as opções de serviço de acordo com a área
  const availableServices = areaData[area] ? Object.keys(areaData[area]) : [];

  const [data, setData] = useState({
    labels: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    datasets: [
      {
        label: "Produção (Kg)",
        data: areaData[area][service].kg,
        borderColor: "#FF8000",
        backgroundColor: "rgba(255, 128, 0, 0.2)",
        borderWidth: 2,
        tension: 0.4,
      },
      {
        label: "Processos",
        data: areaData[area][service].processos,
        borderColor: "#A6A6A6",
        backgroundColor: "rgba(166, 166, 166, 0.2)",
        borderWidth: 2,
        tension: 0.4,
      },
    ],
  });

  // Configuração do gráfico
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#000",
        },
      },
      y: {
        grid: {
          color: "#E0E0E0",
        },
        ticks: {
          color: "#000",
        },
      },
    },
  };
// Função para buscar as encomendas do transformador

  // Atualiza os dados do gráfico quando a área ou serviço é alterado
  React.useEffect(() => {
    setData({
      labels: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
      datasets: [
        {
          label: "Produção (Kg)",
          data: areaData[area][service].kg,
          borderColor: "#FF8000",
          backgroundColor: "rgba(255, 128, 0, 0.2)",
          borderWidth: 2,
          tension: 0.4,
        },
        {
          label: "Processos",
          data: areaData[area][service].processos,
          borderColor: "#A6A6A6",
          backgroundColor: "rgba(166, 166, 166, 0.2)",
          borderWidth: 2,
          tension: 0.4,
        },
      ],
    });
  }, [area, service]);

  return (
    
    <div className="chart-container">
      <div className="chart-header">
        <div className="row">
          <div className="col">
            <h4>Área</h4>
            <select onChange={(e) => setArea(e.target.value)} value={area}>
              <option value="Química">Química</option>
              <option value="Biologia">Biologia</option>
            </select>
          </div>
          <div className="col">
            <h4>Serviço</h4>
            <select onChange={(e) => setService(e.target.value)} value={service}>
              {availableServices.map((serviceOption) => (
                <option key={serviceOption} value={serviceOption}>
                  {serviceOption}
                </option>
              ))}
            </select>
           
          </div>
          <div className="col">
          <h4>Preço</h4>
          <h4>-</h4>
          </div>
          <div className="col">
          <h4>Custo Médio</h4>
          <h4>-</h4>
          </div>

        </div>
      </div>
      <Line data={data} options={options} />
    </div>
  );
};


const TransformerDashboard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [area_insert, setAreaInsert] = useState("");
  const [servico, setServico] = useState("");
  const [preco, setPreco] = useState("");


  const [area, setArea] = useState("Química");
  const [service, setService] = useState("Taninos");
  const [orders, setOrders] = useState([]);
  const transformerId = localStorage.getItem("id"); // Obtém o ID do transformador do localStorage

  const staticData = [
    {
      name: "Encomenda 1",
      address: "Produtor A",
      region: "Zona 1",
      species: "29/05/2024",
      status: "Em espera",
      processoAtual: "Em processamento",
      produtoFinal: "Produto A",
    },
    {
      name: "Encomenda 2",
      address: "Produtor B",
      region: "Zona 2",
      species: "29/05/2024",
      status: "Em espera",
      processoAtual: "Em processamento",
      produtoFinal: "Produto A",
    },
  ];


  // Função para abrir o modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Função para fechar o modal
  const closeModal = () => {
    setIsModalOpen(false);
  };
 // Função para lidar com o envio do formulário
 const handleSubmit = (e) => {
  e.preventDefault();
  // Aqui você pode adicionar a lógica para salvar os dados inseridos
  console.log({ area, servico, preco });
  closeModal();
};


  useEffect(() => {
    const token = localStorage.getItem("token"); // Obtém o token armazenado

    const urlParams = new URLSearchParams(window.location.search);
    const id = localStorage.getItem('id');
    
    const fetchOrders = async () => {
      try {
        const response = await fetch(`${URL}/webland-api/transformador/${transformerId}`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("token")}`, // Adiciona o token no cabeçalho
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`Erro ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        // Filtra apenas as encomendas com status "Processing"
        const filteredOrders = data.filter((order) => order.status === "Processing");
        setOrders(filteredOrders);
      } catch (error) {
        console.error("Erro ao buscar encomendas:", error);
      }
    };
  
    fetchOrders();
  }, [transformerId]);
  return (
   
    <div>
     

      <div 
        className="dashboard-container2" 
        style={{ display: "flex", justifyContent: "space-between", width: "100%"}}
      >
        
        <div 
          className="row" 
          style={{ width: "100%", borderRadius: "1rem",  display: "flex", gap: "1rem" }}
        >
          {/* Container das Tabelas */}
          <div style={{ flex: "1" }}>
            {/* Primeira Tabela - Preços Aprovados */}
            <div 
              className="card-table2" 
              style={{ backgroundColor: "white", borderRadius: "1rem", color: "#5D643F", padding: "1rem", textAlign: "left", marginBottom: "1rem" }}
            >
              <h2 style={{ textAlign: "left" }}>Preços Aprovados</h2>
              <table 
                style={{ width: "100%", borderCollapse: "collapse", padding: "1rem", borderRadius: "1rem", border: "none" }}
              >
                <thead>
                  <tr style={{ color: "#5D643F", textAlign: "left" }}>
                    <th style={{ padding: "8px" }}>Área</th>
                    <th style={{ padding: "8px" }}>Serviço</th>
                    <th style={{ padding: "8px" }}>Estado</th>
                    <th style={{ padding: "8px" }}>Preço (€/Kg)</th>
                  </tr>
                </thead>
                <tbody>
                Ainda sem dados disponíveis
                
                </tbody>
              </table>
            </div>
  
            {/* Segunda Tabela - Preços Pendentes */}
            <div 
              className="card-table2" 
              style={{ backgroundColor: "white", borderRadius: "1rem", color: "#5D643F", padding: "1rem", textAlign: "left" }}
            >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

              <h2 style={{ textAlign: "left" }}>Preços Pendentes</h2>
              
              <button 
          onClick={openModal} 
          style={{ backgroundColor: "#5D643F", color: "white", border: "none", padding: "8px 16px", borderRadius: "50%", fontSize: "18px" }}
        >
          +
        </button>
        </div>
              <table 
                style={{ width: "100%", borderCollapse: "collapse", padding: "1rem", borderRadius: "1rem", border: "none" }}
              >
                <thead>
                  <tr style={{ color: "#5D643F", textAlign: "left" }}>
                    <th style={{ padding: "8px" }}>Área</th>
                    <th style={{ padding: "8px" }}>Serviço</th>
                    <th style={{ padding: "8px" }}>Estado</th>
                    <th style={{ padding: "8px" }}>Preço (€/Kg)</th>
                  </tr>
                </thead>
                <tbody>
                Ainda sem dados disponíveis
                </tbody>
              </table>
                    {/* Modal */}
      {isModalOpen && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.modal}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <h3 style={{ margin: 0 }}>Adicionar Preço</h3>
    <button
      style={{
        background: 'none',
        border: 'none',
        fontSize: '1.2rem',
        cursor: 'pointer',
        color: '#555'
      }}
      onClick={closeModal}
      aria-label="Fechar"
    >
      ×
    </button>
  </div>
            <form onSubmit={handleSubmit}>
          
              <div style={modalStyles.inputGroup}>
                <label>Área</label>
                <input 
                  type="text" 
                  value={area} 
                  onChange={(e) => setArea(e.target.value)} 
                  style={modalStyles.input}
                  required
                />
              </div>
              <div style={modalStyles.inputGroup}>
                <label>Serviço</label>
                <input 
                  type="text" 
                  value={servico} 
                  onChange={(e) => setServico(e.target.value)} 
                  style={modalStyles.input}
                  required
                />
              </div>
              <div style={modalStyles.inputGroup}>
                <label>Preço (€ / Kg)</label>
                <input 
                  type="number" 
                  value={preco} 
                  onChange={(e) => setPreco(e.target.value)} 
                  style={modalStyles.input}
                  required
                />
              </div>
              <div style={modalStyles.buttons}>
                <button type="submit" style={modalStyles.button}>Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}
            </div>
          </div>
        
          {/* Container do Gráfico */}
          <div 
  className="chart-container" 
  style={{ flex: "1", backgroundColor: "white", borderRadius: "1rem", padding: "1rem", color: "#5D643F", position: "relative" }}
>
  {/* Renderiza o gráfico */}
  <LineChartComponent area={area} service={service} setArea={setArea} setService={setService} />

  {/* Sobreposição com a mensagem */}
  {orders.length === 0 && (
    <div 
      className="chart-overlay" 
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Fundo semitransparente
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "#5D643F",
        fontSize: "1.2rem",
        fontWeight: "bold",
        zIndex: 10,
      }}
    >
      Sem dados disponíveis para o gráfico
    </div>
  )}
</div>
        </div>
      </div>
  
      {/* Tabela de Encomendas */}
      <div className="tables-container-wrapper">
        <div className="tables-container">
          <div className="card-table2">
            <div className="card-table2-header">
              <div className="card-table2-title">Encomendas a decorrer</div>
            </div>
            <div className="card-table2-body">
            {orders.length === 0 ? (
                <p style={{ textAlign: "center", color: "#5D643F" }}>
                  Sem encomendas em processamento
                </p>
              ) : (
                <table>
                  <thead>
                    <tr>
                      <th>Encomenda</th>
                      <th>Data Prevista Entrega</th>
                      <th>Data que Recebeu</th>
                      <th>Data Provisória de Conclusão</th>
                      <th>Estado</th>
                      <th>Processo Atual</th>
                      <th>Produto Final</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((order, index) => (
                      <tr key={index}>
                        <td>{order._id}</td>
                        <td>{order.expectedDeliveryDate || "N/A"}</td>
                        <td>{order.receivedDate || "N/A"}</td>
                        <td>{order.provisionalCompletionDate || "N/A"}</td>
                        <td>{order.status}</td>
                        <td>{order.currentProcess || "N/A"}</td>
                        <td>{order.finalProduct || "N/A"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
      
    </div>
    
  );
  
};

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    width: "350px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  inputGroup: {
    marginBottom: "15px",
  },
  input: {
    width: "90%",
    padding: "8px",
    marginTop: "5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  buttons: {
    display: "flex",
    justifyContent: "space-between",
  },
  button: {
    padding: "8px 16px",
    backgroundColor: "#5D643F",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};
export default TransformerDashboard;
